const pincodeUrl = 'https://api.postalpincode.in/pincode';

//----------------localhost------------//
// const apiUrl = 'http://localhost:8017';
// const tokenUrl = 'http://localhost:8001';
// const envCode = 'Local';

//----------72.61.232.229-------------//
const apiUrl = 'https://ap.trucred.in:7017';
const tokenUrl = 'https://au.trucred.in:7001';
const envCode = 'Prod';

export const gridSpacing = 2;
export const drawerWidth = 250;
export const collapsedDrawerWidth = 250;
export const appDrawerWidth = 200;
export const SECRET_KEY = 'TruCred$EncryptKey@2025#SecureAES32';

export { envCode, apiUrl, tokenUrl, pincodeUrl };
